<template>
  <RemoveComponent v-bind="$attrs" v-on="$listeners">
    <div>
      <div class="mb-1">
        <strong>{{ $t('removeRelationsTitle') }}</strong>
      </div>
      <div v-for="item in relations" :key="item">
        <FontAwesomeIcon :icon="['fal', 'check-square']" class="mr-1" />
        <span>{{ $tc(item, 2) }}</span>
      </div>
    </div>
  </RemoveComponent>
</template>

<script>
import RemoveComponent from '@/components/Remove'
export default {
  data() {
    return {
      relations: ['lead', 'openhouse'],
    }
  },
  components: {
    RemoveComponent,
  },
}
</script>

<style lang="scss"></style>
